import { FC } from "react";
import cx from 'classnames';
import sanitizeHtml from 'sanitize-html';
import styles from './index.module.scss';
import { CommonImage } from "@/components";
import { pagePathUrl } from "@/constants/url";
import { ImageType } from "@/components/CommonImage";
import { ArticalCoverEnum, IThreadLisItem } from "@/api/thread/list";

const ConsultCard:FC<IThreadLisItem> = (props: IThreadLisItem) => {
  const {
    tid,
    subject,
    summary,
    covers = [],
  } = props;

  const handleGotoDetail = (e: any) => {
    e.stopPropagation();
    if (tid) {
      window.open(`${pagePathUrl.detail}?tid=${tid}`);
    }
  };
  return (
    <div className={styles.consultCard} onClick={handleGotoDetail}>
      <div
        className={styles.consultContent}
        style={{
          maxWidth: !!covers.length ? '444px' : 'none'
        }}
      >
        {subject && (
          <div
            className={styles.subject}
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(subject) }}
          />
        )}

        {summary && (
          <div
            className={styles.summary}
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(summary) }}
          />
        )}

      </div>
      {!!covers.length && (
        <div className={cx(styles.consultImage, covers[0].type  === ArticalCoverEnum.image ? '' : styles.play)}>
          <CommonImage
            layout="fill"
            cutMode="cover"
            draggable={false}
            src={covers[0].medium as string}
            type={ImageType.image}
          />
        </div> 
      )}
    </div>
  )
}

export default ConsultCard;
